module.exports = __webpack_public_path__ + "static/hero_visual_title_b-3ecd28823a65d46c0d7342e34a6da34b.png";